import { useAccountRepository } from '@frontend/repository';

import { useAppDispatch } from '../../../redux/store';

export const useInventory = () => {
    const dispatch = useAppDispatch();
    const { currentAccount } = useAccountRepository();
    const listId = 'laundry-inventory-list';

    return {
        listId,
        dispatch,
        currentAccount
    };
};
